// var showLoading = false;

// export default { showLoading };
module.exports = {
  showLoading: false
};



// WEBPACK FOOTER //
// ./src/assets/js/globalData.js